/* modules imports */
import { useState } from "react";

/* types imports */
import type { FC } from "react";
import type { ArtistEntity } from "services/artist";
import type { Actions } from "constants/game";

/* project files imports */
import Card from "pages/Play/Card";
import { DEMO_ARTISTS } from "constants/demo";
import { NB_ARTISTS_PER_GAME } from "constants/game";
import Services from "constants/service";
import { selectChoice } from "utils/game";

/* styles imports */
import { CardWrapper, Main, Text } from "./index.styles";

/**
 * Pick random demo artists, shaped like the artists returned by the API
 * @returns {ArtistEntity[]} The picked artists
 */
const pickDemoArtists = (): ArtistEntity[] => {
  const pool = [...DEMO_ARTISTS];

  return [...Array(NB_ARTISTS_PER_GAME)].map(() => {
    const [{ name, picture }] = pool.splice(Math.floor(Math.random() * pool.length), 1);

    return {
      id: name,
      name,
      profiles: [{
        id: name,
        service: Services.SPOTIFY,
        profileId: name,
        profileUrl: "",
        profilePicture: picture
      }]
    };
  });
};

type DemoProps = {
  onDone: () => void;
};

const Demo:FC<DemoProps> = ({ onDone }) => {
  const [artists] = useState<ArtistEntity[]>(pickDemoArtists);
  const [choices, setChoices] = useState<(Actions | null)[]>([null, null, null]);

  const isDone = choices.every((choice) => choice !== null);

  const handleChoiceSelection = (action: Actions, cardIndex: number): void => {
    // choices are locked while the login page fades out
    if (isDone) return;

    const mappedChoices = selectChoice(choices, action, cardIndex);

    setChoices(mappedChoices);

    if (mappedChoices.every((choice) => choice !== null)) onDone();
  };

  return (
    <Main>
      <Text>
        Who would you fuck, marry... kill?
      </Text>
      <CardWrapper>
        {artists.map((artist, index) => (
          <Card
            key={artist.id}
            artist={artist}
            cardIndex={index}
            choice={choices[index]}
            handleChoiceSelection={handleChoiceSelection}
          />
        ))}
      </CardWrapper>
    </Main>
  );
};

export default Demo;
